/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { GetSidebarState200ResponseData } from './GetSidebarState200ResponseData'
import {
  GetSidebarState200ResponseDataFromJSON,
  GetSidebarState200ResponseDataFromJSONTyped,
  GetSidebarState200ResponseDataToJSON,
} from './GetSidebarState200ResponseData'

/**
 *
 * @export
 * @interface GetSidebarState200Response
 */
export interface GetSidebarState200Response {
  /**
   *
   * @type {boolean}
   * @memberof GetSidebarState200Response
   */
  status: boolean
  /**
   *
   * @type {GetSidebarState200ResponseData}
   * @memberof GetSidebarState200Response
   */
  data: GetSidebarState200ResponseData
}

/**
 * Check if a given object implements the GetSidebarState200Response interface.
 */
export function instanceOfGetSidebarState200Response(
  value: object
): value is GetSidebarState200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function GetSidebarState200ResponseFromJSON(
  json: any
): GetSidebarState200Response {
  return GetSidebarState200ResponseFromJSONTyped(json, false)
}

export function GetSidebarState200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetSidebarState200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: GetSidebarState200ResponseDataFromJSON(json['data']),
  }
}

export function GetSidebarState200ResponseToJSON(
  value?: GetSidebarState200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: GetSidebarState200ResponseDataToJSON(value['data']),
  }
}
